module.exports = __webpack_public_path__ + "static/media/inactive.eff5066f.svg";